
import React, { useEffect, useState } from 'react';
import { motion, useSpring, useTransform } from 'framer-motion';

interface AnimatedCounterProps {
  value: number;
  duration?: number;
  format?: 'number' | 'currency' | 'percentage';
  className?: string;
  prefix?: string;
  suffix?: string;
  decimals?: number;
}

export const AnimatedCounter: React.FC<AnimatedCounterProps> = ({
  value,
  duration = 1,
  format = 'number',
  className = '',
  prefix = '',
  suffix = '',
  decimals = 0,
}) => {
  const spring = useSpring(value, { duration: duration * 1000 });
  
  const display = useTransform(spring, (latest) => {
    let formatted: string;
    
    switch (format) {
      case 'currency':
        formatted = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
          minimumFractionDigits: decimals,
          maximumFractionDigits: decimals,
        }).format(latest);
        break;
      case 'percentage':
        formatted = `${latest.toFixed(decimals)}%`;
        break;
      default:
        formatted = latest.toFixed(decimals);
    }
    
    return `${prefix}${formatted}${suffix}`;
  });

  return (
    <motion.span
      className={className}
      initial={{ opacity: 0, scale: 0.5 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.3 }}
    >
      {display}
    </motion.span>
  );
};
